module.exports = __webpack_public_path__ + "static/material-table-basic-4e8c65508c069e620314b1ab3f081aa1.png";